/**
 * Used when error response from server contained error message intended for users (field user_message in JSON payload)
 *
 * This should not contain generic error messages or messages intended for developer.
 */
export class ErrorWithUserMessage {
    public readonly name = 'ErrorWithUserMessage';

    constructor(
        public readonly message: string,
    ) {
    }
}
